import script from "./KioskView.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskView.vue?vue&type=script&setup=true&lang=js"

import "./KioskView.vue?vue&type=style&index=0&id=0d639542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d639542"]])

export default __exports__